import restClient from '.';
import { WS_TOKEN } from '../constants/api-url';
import { getJwtToken } from './refreshToken';

const exchangeWsToken = async (): Promise<string | null> => {
  const jwt = await getJwtToken();
  if (!jwt) {
    return null;
  }
  const { data } = await restClient.post(WS_TOKEN, null, { params: { token: jwt } });
  return data.token;
};

export default exchangeWsToken;
